import React, {useState, useContext} from 'react';
import {AlertContext} from "../../../../../context/alert.context";
import styles from './index.module.scss'
import Loader from "../../../../../../components/Loader";

export default function PaginationBtn({closePaginate, setClosePaginate, folderId, isReady, getMedicalCard, perPage}){
    const {setAlertError} = useContext(AlertContext)
    const [page, setPage] = useState(1);

    const paginationHandler = async () => {
        try {
            const requestData = {
                offset: perPage * page + 1,
                limit: perPage,
                withPagination: true
            }

            const medCards = await getMedicalCard(requestData)

            if(!medCards || (medCards.length < perPage)){
                setClosePaginate(true)
            }

            setPage(page + 1)
        }
        catch (e){
            setAlertError(e?.message)
        }
    }

    if(closePaginate){
        return null
    }

    return (
        <div onClick={paginationHandler} className={`${styles.btn} ${!isReady && styles.disabled}`}>
            {!isReady && (
                <div  className={styles.btn__loader}>
                    <Loader />
                </div>
            )}
            SHOW  MORE
        </div>
    )
}
